import _classCallCheck from "/Users/akshaypetta/Documents/React Studio/Exported Projects/Minted/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/akshaypetta/Documents/React Studio/Exported Projects/Minted/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/akshaypetta/Documents/React Studio/Exported Projects/Minted/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/akshaypetta/Documents/React Studio/Exported Projects/Minted/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/akshaypetta/Documents/React Studio/Exported Projects/Minted/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/akshaypetta/Documents/React Studio/Exported Projects/Minted/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ValueWithRandom } from "../../ValueWithRandom";
import { setRangeValue } from "../../../../Utils";
export var Repulse = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(Repulse, _ValueWithRandom);

  function Repulse() {
    var _this;

    _classCallCheck(this, Repulse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Repulse).call(this));
    _this.enabled = false;
    _this.distance = 1;
    _this.duration = 1;
    _this.factor = 1;
    _this.speed = 1;
    return _this;
  }

  _createClass(Repulse, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(Repulse.prototype), "load", this).call(this, data);

      if (!data) {
        return;
      }

      if (data.enabled !== undefined) {
        this.enabled = data.enabled;
      }

      if (data.distance !== undefined) {
        this.distance = setRangeValue(data.distance);
      }

      if (data.duration !== undefined) {
        this.duration = setRangeValue(data.duration);
      }

      if (data.factor !== undefined) {
        this.factor = setRangeValue(data.factor);
      }

      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }
    }
  }]);

  return Repulse;
}(ValueWithRandom);